module.exports = __webpack_public_path__ + "img/07.77de5cee.png";